import { App } from 'vue';

import { FONT_STYLE } from '@constants/font-style';

const FontStylePlugin = {
  install(app: App) {
    app.provide('$fontStyle', FONT_STYLE);
  },
};

export default FontStylePlugin;
